export default {
  uploadImageWrapper: {
    width: '100%'
  },
  uploadImage: {
    paddingBottom: '56%',
    background: '#f9f9f9',
    border: '1px solid #ddd',
    borderRadius: '5px',
    position: 'relative',
    cursor: 'pointer'
  },
  uploadIcon: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    fontSize: '30px',
    margin: '-15px 0 0 -15px',
    color: '#c3c3c3'
  },
  optionsHolder: {
    marginTop: '20px',
    padding: '8px',
    display: 'flex'
  },
  option: {
    width: 'calc(33.333% - 12px)',
    margin: '6px'
  },
  mainImage: {
    display: 'block',
    backgroundColor: '#f9f9f9',
    width: '100%',
    paddingBottom: '56%',
    borderRadius: '5px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    cursor: 'pointer'
  }
}
